import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex h-full min-h-0 flex-col gap-5 overflow-hidden p-4 xl:p-8" };
import { NotificationPreferencesPanel } from "@/domains/notification/components";
export default /*@__PURE__*/ _defineComponent({
    __name: 'NotificationPreferencesIndex',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(NotificationPreferencesPanel))
            ]));
        };
    }
});
